const redirect = (route) => window && window.location.assign(route);
export {
  redirect
};
//# sourceMappingURL=redirect.js.map
